import React, {Component} from 'react'
import { Parallax, Background } from 'react-parallax'
import get from 'lodash/get'
import {
  Carousel,
  CarouselItem,
  CarouselControl,
  CarouselIndicators,
  CarouselCaption,
  Container, 
  Row, 
  Col,
  Jumbotron
} from 'reactstrap';
import img0 from '../img/home-alive-calling.png'
import img1 from '../img/home10.png'
import img2 from '../img/home11.png'
import img3 from '../img/home1.jpg'
import img4 from '../img/home7.png'
import img5 from '../img/home8.png'
import img6 from '../img/ifgf-austin-tag1.jpg'
import styled from 'styled-components';
import Link from 'gatsby-link';
import {SocialIcon} from 'react-social-icons';


const CampusText = styled.div`
font-size: 40px;
text-align:right;
text-transform: uppercase;
white-space:nowrap;
`;

const HeadlineHeadText = styled.div`
font-size: 32px;
text-transform: uppercase;
`;

const HomeText = styled.div`
font-size: 18px;
`;

const items = [

  
  {
    src: img0,
    altText: '',
    caption: ''
  },
  {
    src: img1,
    altText: '',
    caption: ''
    
  },
  {
    src: img2,
    altText: '',
    caption: ''
    
  },
  {
    src: img3,
    altText: '',
    caption: ''
    
  },
  {
    src: img5,
    altText: '',
    caption: ''
    
  },
  {
    src: img6,
    altText: '',
    caption: ''
  }
  
];

class RootIndex extends Component {
  constructor(props) {
    super(props);
    this.state = { activeIndex: 0 };
    this.next = this.next.bind(this);
    this.previous = this.previous.bind(this);
    this.goToIndex = this.goToIndex.bind(this);
    this.onExiting = this.onExiting.bind(this);
    this.onExited = this.onExited.bind(this);

    this.announcementModuleShow = false;
    this.announcementModuleStartDate = new Date();
    this.announcementModuleEndDate = new Date();
  
  }

  componentDidMount() {
      //debugger;
      var _datetime = new Date();
      var _startDate = new Date(this.announcementModuleStartDate);
      var _endDate = new Date(this.announcementModuleEndDate);
     
      if (this.announcementModuleShow
            && _datetime >= _startDate
            && _datetime <= _endDate
            )
      {
        document.getElementById('divAnnouncement').style.display='block';
      }
      else 
      {
        document.getElementById('divAnnouncement').style.display='none';
      }

/*
      if (_datetime > new Date("04/18/2021 15:00:00") && _datetime < new Date("05/02/2021 15:00:00") ) 
      {
        document.getElementById('reserve0502').style.display='block';
      }

      if (_datetime > new Date("04/25/2021 15:00:00") && _datetime < new Date("05/09/2021 15:00:00") ) 
      {
        document.getElementById('reserve0509').style.display='block';
      }

      if (_datetime > new Date("05/02/2021 15:00:00") && _datetime < new Date("05/16/2021 15:00:00") ) 
      {
        document.getElementById('reserve0516').style.display='block';
      }

      if (_datetime > new Date("05/09/2021 15:00:00") && _datetime < new Date("05/23/2021 15:00:00") ) 
      {
        document.getElementById('reserve0523').style.display='block';
      }

      if (_datetime > new Date("05/16/2021 15:00:00") && _datetime < new Date("05/30/2021 15:00:00") ) 
      {
        document.getElementById('reserve0530').style.display='block';
      }

      if (_datetime > new Date("05/23/2021 15:00:00") && _datetime < new Date("06/06/2021 15:00:00") ) 
      {
        document.getElementById('reserve0606').style.display='block';
      }

      if (_datetime > new Date("05/30/2021 15:00:00") && _datetime < new Date("06/13/2021 15:00:00") ) 
      {
        document.getElementById('reserve0613').style.display='block';
      }

      if (_datetime > new Date("06/06/2021 15:00:00") && _datetime < new Date("06/20/2021 15:00:00") ) 
      {
        document.getElementById('reserve0620').style.display='block';
      }

      if (_datetime > new Date("06/13/2021 15:00:00") && _datetime < new Date("06/27/2021 15:00:00") ) 
      {
        document.getElementById('reserve0627').style.display='block';
      }

      if (_datetime > new Date("06/20/2021 15:00:00") && _datetime < new Date("07/04/2021 15:00:00") ) 
      {
        document.getElementById('reserve0704').style.display='block';
      }

      if (_datetime > new Date("06/27/2021 15:00:00") && _datetime < new Date("07/11/2021 15:00:00") ) 
      {
        document.getElementById('reserve0711').style.display='block';
      }

      if (_datetime > new Date("07/04/2021 15:00:00") && _datetime < new Date("07/18/2021 15:00:00") ) 
      {
        document.getElementById('reserve0718').style.display='block';
      }
      
      if (_datetime > new Date("07/11/2021 15:00:00") && _datetime < new Date("07/25/2021 15:00:00") ) 
      {
        document.getElementById('reserve0725').style.display='block';
      }
      
*/

  }
  
  onExiting() {
    this.animating = true;
  }

  onExited() {
    this.animating = false;
  }

  next() {
    if (this.animating) return;
    const nextIndex = this.state.activeIndex === items.length - 1 ? 0 : this.state.activeIndex + 1;
    this.setState({ activeIndex: nextIndex });
  }
  
  previous() {
    if (this.animating) return;
    const nextIndex = this.state.activeIndex === 0 ? items.length - 1 : this.state.activeIndex - 1;
    this.setState({ activeIndex: nextIndex });
  }

  goToIndex(newIndex) {
    if (this.animating) return;
    this.setState({ activeIndex: newIndex });
  }

 

  
  render() {

    /*
    //Sample to send variable during Gatsby's rendering.
    const ShowFlag = (showFlag,startDate,endDate) => {
      var _startDate = new Date(startDate);
      var _endDate = new Date(endDate);
      var _datetime = new Date();
      
      return (
        ( showFlag
          &&_datetime >= _startDate 
          && _datetime <= _endDate
          ) 
      );
    }
    */

    const { activeIndex } = this.state;
    const [announcementModuleObj] =  get(this, 'props.data.allContentfulModule.edges')
    const upcomingEvents = get(this, 'props.data.allContentfulUpcomingEvents.edges')
    var linkurl;
 
    //Setting the property of the announcement Module to the client.
    if (announcementModuleObj.node.show) {
    this.announcementModuleShow = true;
    }
    else {
      this.announcementModuleShow = false;
    }
    this.announcementModuleShow = announcementModuleObj.node.show;
    this.announcementModuleStartDate =  announcementModuleObj.node.startDate;
    this.announcementModuleEndDate = announcementModuleObj.node.endDate;

    const slides = items.map((item) => {
      return (
        <CarouselItem
          onExiting={this.onExiting}
          onExited={this.onExited}
          key={item.src}
        >
          <img src={item.src} alt={item.altText} />
          <CarouselCaption captionHeader={item.caption} captionText='' />
        </CarouselItem>
      );
    });

    return (
        <div>
              <Container style={{ background:'white', maxWidth: 1200, margin: 'auto', padding: '0px' }}>
              <Row >
                <Col sm="12">
                <Carousel
                      activeIndex={activeIndex}
                      next={this.next}
                      previous={this.previous}
                    >
                      <CarouselIndicators items={items} activeIndex={activeIndex} onClickHandler={this.goToIndex} />
                      {slides}
                      <CarouselControl direction="prev" directionText="Previous" onClickHandler={this.previous} />
                      <CarouselControl direction="next" directionText="Next" onClickHandler={this.next} />
                    </Carousel>
                </Col>
              </Row>
              <Row>
                <Col sm="12" style={{textAlign:'center'}}>
                To be a <i><b>MULTI-ETHNIC</b></i> church where all people find it <i><b>IRRESISTIBLE</b></i>, <i><b>ENGAGING</b></i> and <i><b>IMPACTFUL</b></i>
                </Col>
              </Row>
              <Row style={{paddingTop:50, paddingLeft:50, paddingRight:50}}>
              <Col>
                  <h2>IFGF Austin In-person Worship</h2>
                  <b>Every Sunday 10.30AM</b> 
                  <p></p>
                </Col>
                <Col>
                  <h2>IFGF Austin Online</h2>
                  <b>Every Sunday 10.30AM</b> 
                  <p></p>
                </Col>
              </Row>
              <Row style={{paddingLeft:50, paddingRight:50, height:100}}>
               <Col>
                 
                 <div id="reservenomore" style={{display:'none'}}>
                  RSVP is no longer required (Face Mask is required) for attending our weekly worship service.
                  <br /><br />
                  </div>


                  <div id="reserve0620" style={{display:'none'}}>
                  <p></p>
                  <b> Father's Day (June 20th) In-person Worship</b>
                  <br/> <button style={{color:'#ffffff', backgroundColor:'#ff6600'}} id="btn-rsvp-0620" type="button">RSVP for Father's Day (June 20th)</button>
                  <p></p>
                  <hr />
                  </div>

                  <div id="reserve0502" style={{display:'none'}}>
                  <p></p>
                  <b> May 2nd In-person Worship</b>
                  <br/> <button style={{color:'#ffffff', backgroundColor:'#ff6600'}} id="btn-rsvp-0502" type="button">RSVP for May 2nd</button>
                  <p></p>
                  <hr />
                  </div>

                  <div id="reserve0516" style={{display:'none'}}>
                  <p></p>
                  <b> May 16th In-person Worship</b>
                  <br/> <button style={{color:'#ffffff', backgroundColor:'#ff6600'}} id="btn-rsvp-0516" type="button">RSVP for May 16th</button>
                  <p></p>
                  <hr />
                  </div>

                  <div id="reserve0523" style={{display:'none'}}>
                  <p></p>
                  <b> May 23rd In-person Worship</b>
                  <br/> <button style={{color:'#ffffff', backgroundColor:'#ff6600'}} id="btn-rsvp-0523" type="button">RSVP for May 23rd</button>
                  <p></p>
                  <hr />
                  </div>

                  <div id="reserve0530" style={{display:'none'}}>
                  <p></p>
                  <b> May 30th In-person Worship</b>
                  <br/> <button style={{color:'#ffffff', backgroundColor:'#ff6600'}} id="btn-rsvp-0530" type="button">RSVP for May 30th</button>
                  <p></p>
                  <hr />
                  </div>


                  <div id="reserve0606" style={{display:'none'}}>
                  <p></p>
                  <b> June 6th In-person Worship</b>
                  <br/> <button style={{color:'#ffffff', backgroundColor:'#ff6600'}} id="btn-rsvp-0606" type="button">RSVP for June 6th</button>
                  <p></p>
                  <hr />
                  </div>


                  <div id="reserve0613" style={{display:'none'}}>
                  <p></p>
                  <b> June 13th In-person Worship</b>
                  <br/> <button style={{color:'#ffffff', backgroundColor:'#ff6600'}} id="btn-rsvp-0613" type="button">RSVP for June 13th</button>
                  <p></p>
                  <hr />
                  </div>

                  <div id="reserve0627" style={{display:'none'}}>
                  <p></p>
                  <b> June 27th In-person Worship</b>
                  <br/> <button style={{color:'#ffffff', backgroundColor:'#ff6600'}} id="btn-rsvp-0627" type="button">RSVP for June 27th</button>
                  <p></p>
                  <hr />
                  </div>


                  <div id="reserve0704" style={{display:'none'}}>
                  <p></p>
                  <b> July 4th In-person Worship</b>
                  <br/> <button style={{color:'#ffffff', backgroundColor:'#ff6600'}} id="btn-rsvp-0704" type="button">RSVP for July 4th</button>
                  <p></p>
                  <hr />
                  </div>


                  <div id="reserve0711" style={{display:'none'}}>
                  <p></p>
                  <b> July 11th In-person Worship</b>
                  <br/> <button style={{color:'#ffffff', backgroundColor:'#ff6600'}} id="btn-rsvp-0711" type="button">RSVP for July 11th</button>
                  <p></p>
                  <hr />
                  </div>


                  <div id="reserve0718" style={{display:'none'}}>
                  <p></p>
                  <b> July 18th In-person Worship</b>
                  <br/> <button style={{color:'#ffffff', backgroundColor:'#ff6600'}} id="btn-rsvp-0718" type="button">RSVP for July 18th</button>
                  <p></p>
                  <hr />
                  </div>


                  <div id="reserve0725" style={{display:'none'}}>
                  <p></p>
                  <b> July 25th In-person Worship</b>
                  <br/> <button style={{color:'#ffffff', backgroundColor:'#ff6600'}} id="btn-rsvp-0725" type="button">RSVP for July 25th</button>
                  <p></p>
                  <hr />
                  </div>



               </Col>
                <Col>
                 {/* 
                <a href="https://www.ifgfaus.org/livestream">IFGF Austin Website</a> 
                &nbsp;&nbsp;
                | <a href="https://vimeo.com/event/25088" target="_new">Vimeo</a>
                &nbsp;&nbsp;
                |   */} 
                
                <a href="https://www.youtube.com/channel/UCdgH27j2WrfL5oeiqEWKwOw/live" target="_new">YouTube</a>
                &nbsp;&nbsp;
                | <a href="https://www.facebook.com/ifgfaustin" target="_new">Facebook</a>
                </Col>
              </Row>
              <Row>
                <Col>
                <div id="divAnnouncement" >
                      <HeadlineHeadText>
                          { announcementModuleObj.node.frontlineHeadline }
                      </HeadlineHeadText>
                  <hr className="my-2" />
                  <div
                        dangerouslySetInnerHTML={{ __html:  announcementModuleObj.node.childContentfulModuleContentTextNode.childMarkdownRemark.html }}
                  />
              </div>
                </Col>
              </Row>
              <Row>
                  <Col sm="5">
                    <CampusText>
                    Austin
                    <br />
                    San Antonio
                    <br />
                    St. Louis
                    </CampusText>
                  </Col>
                  <Col sm="7">
                  <HomeText>
                    International Full Gospel Fellowship (IFGF) is an Apostolic Denomination church which is concerned with 
                    reaching the lost and ministering outside the four wall of the church. 
                    We aimed to bring an impact to the communities, cities and nations using many means, 
                    such as church planting, humanitarian and compassion ministries, prayer, community development, and education.
                    <p></p>
                    The word “apostle” has been used to describe variety of things. 
                    The earliest mention of “apostle” were to describe Jesus’ disciples (Mat 10:2-4).
                    <p style={{textAlign:"right", paddingRight:'30px'}} >
                    <Link to="/about-ifgf/" style={{color:"red"}}>>>read more</Link>
                    </p>
                  </HomeText>
                  </Col>
                </Row>
            </Container>
            <Container style={{ background:'white', maxWidth: 1200, margin: '0 auto', padding: '0px' }}>
               <Row>
              <Col>
              <div style={{padding:20}} >
              <HeadlineHeadText>
                Upcoming Events
              </HeadlineHeadText>
              <hr className="my-2" />
              <ul className="upcomingeventsfront-list">
                {
                  upcomingEvents.map(({ node }) => {
                  if (node.header == null || Date.parse(node.expiredDate) <= new Date()) {
                    return ("");
                  }
                  else {
                     
                      return (
                        <li>
                          <b>{node.eventDate}</b>
                          <br />
                          <b className='blue'>{node.header}</b>
                          <br />
                          <div style={{width:'70%', display:'inline-block'}}
                                                                      dangerouslySetInnerHTML={{ __html: node.frontPageDescription.childMarkdownRemark.html }}
                                                                  />
                          {
                            /*

                            <a href= {'events/#' + node.header.replace(' ','')}>more info</a>
                            */
                            }
                        </li>
                        )
                      
                    }
                  }
                )
                }
              </ul>

              </div>

              </Col>
              </Row>
              </Container>

              



      </div>


    )
  }
}

export default RootIndex

export const pageQuery = graphql`
  query RootIndexQuery
  {
    allContentfulModule (filter: { id: { eq:"c69cXxaPWCsYueAU6SGOOcA" }}) {
      edges
      {
        node  {
          content {
              content
          },
          childContentfulModuleContentTextNode {
            childMarkdownRemark {
              html
            }
          },
          show,
          frontlineHeadline,
          startDate(formatString: "YYYY-MM-DD"),
          endDate(formatString: "YYYY-MM-DD")
        }
      }
    }

    allContentfulUpcomingEvents (sort: {fields: [eventDate], order:ASC} ) {
      edges {
        node {
          id
          description {
            id,
            childMarkdownRemark
            {
              html
            }
          }
          frontPageDescription {
            id,
            childMarkdownRemark
            {
              html
            }
          }
          expiredDate 
          eventDate (formatString:"MMM DD, YYYY")
          header
          
        },
        }
      }

  }
`



// WEBPACK FOOTER //
// ./src/pages/index.js